export { default } from './Modal2';
export { default as Title } from './components/ModalTitle';
export { default as Subtitle } from './components/ModalSubtitle';
export { default as Image } from './components/ModalImage';
export { default as Description } from './components/ModalDescription';
export { default as Content } from './components/ModalContent';
export { default as Footer } from './components/ModalFooter';
export { default as Help } from './components/ModalHelp';
export { default as Scroll } from './components/ModalScroll';
export { default as Trigger } from './components/ModalTrigger';
export { default as Inner } from './components/ModalInner';
export { default as CloseIcon } from './components/ModalCloseIcon';
